export enum TransformationEnum {
    RAPID_FIRE_GROUPING
}
